import { FC, useEffect } from "react";

import { HelpDeskColored, LiveChatColored } from "@livechat/design-system-icons";
import { DesignToken, Icon, SpacingToken } from "@livechat/design-system-react-components";

import imageSrc from "assets/img/welcome/ticket-form.png";
import Text from "components/layout/Text";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { withVar } from "themes/helpers";

import { WelcomeTutorialRoutes } from "../helpers";

import TitleOnboardingStep from "./TitleOnboardingStep";

const TicketFormStep: FC = () => {
  useEffect(() => {
    trackEngagement("LC integration: Welcome screens", EventPlace.Onboarding, {
      step: 2,
    });
  }, []);

  return (
    <TitleOnboardingStep
      currentStep={2}
      title={
        <Text
          // TODO: replace with Heading component when DS adds new size
          fontWeight="600"
          fontSize="40px"
          lineHeight="54px"
          color={withVar(DesignToken.ContentBasicPrimary)}
          marginV={withVar(SpacingToken.Spacing4)}
        >
          Support customers even when <br /> you&apos;re away
        </Text>
      }
      subtitle={
        <>Use ticket forms to collect tickets submitted in chats. Address them in HelpDesk when you&apos;re ready.</>
      }
      imageSource={imageSrc}
      firstIcon={<Icon source={HelpDeskColored} />}
      secondIcon={<Icon source={LiveChatColored} />}
      nextButtonRouteLink={WelcomeTutorialRoutes.LC_MANAGEABLE_TICKETS}
      backButtonRouteLink={WelcomeTutorialRoutes.LC_MANAGE_EMAILS}
    />
  );
};

export default TicketFormStep;
